export const PREFIX_LIST = [
    "🤾", "🤹", "🤺", "🏇", "⛷️", "🏂", "🏌️", "🏄", "🚣", "🏊", "⛹️", "🏋️", "🚴", "🤸", "🤽", "🍆", "☠️",
    "👷", "🚜", "👨‍🌾", "👩‍🌾", "👩‍💻", "👨‍🚀", "👮", "💂", "🥷", "🤴", "👸", "🤰", "🫃", "🕵️", "🌳", "🎮", "♠️",
    "♦️", "♣️", "🍺", "🍻", "🤖", "🥃", "🥂", "🧌", "🧙", "🫡", "🪖", "💣", "🚍", "🛻", "🐖", "💩", "🚐",
    "🤡", "👻", "👽", "💤", "🧠", "🫀", "🫁", "🦷", "🤷‍", "🧑‍🍳", "🧑‍🚒", "🎅", "🦸", "🧚‍", "🧟", "🚶", "🧍",
    "🐻", "🐕", "🐈", "🐢", "🐍", "🐠", "🐟", "🐬", "🐳", "🐋", "🐊", "🐆", "🐅", "🐃", "🐂", "🐄", "🐪",
    "🏍️", "🚗", "🚙", "🚚", "🚛", "🚲", "🛴", "🚨", "🚓", "🚔", "🚒", "🚑"
];
